// extracted by mini-css-extract-plugin
export default {"sendMessageButton":"EmailMessageForm_sendMessageButton__vi-cY","lineBreaker":"EmailMessageForm_lineBreaker__1kRS5"};